import Instagram from "/images/platforms/instagram.svg";
import Facebook from "/images/platforms/facebook.svg";
import Pinterest from "/images/platforms/pinterest.svg";
import Youtube from "/images/platforms/youtube.svg";
import Tiktok from "/images/platforms/tiktok.svg";

import InstagramHover from "/images/platforms/instagram_hover.svg";
import FacebookHover from "/images/platforms/facebook_hover.svg";
import PinterestHover from "/images/platforms/pinterest_hover.svg";
import YoutubeHover from "/images/platforms/youtube_hover.svg";
import TiktokHover from "/images/platforms/tiktok_hover.svg";

import InstagramSelected from "/images/platforms/instagram_selected.svg";
import FacebookSelected from "/images/platforms/facebook_selected.svg";
import PinterestSelected from "/images/platforms/pinterest_selected.svg";
import YoutubeSelected from "/images/platforms/youtube_selected.svg";
import TiktokSelected from "/images/platforms/tiktok_selected.svg";

import InstagramDisabled from "/images/platforms/instagram_disabled.svg";
import FacebookDisabled from "/images/platforms/facebook_disabled.svg";
import PinterestDisabled from "/images/platforms/pinterest_disabled.svg";
import YoutubeDisabled from "/images/platforms/youtube_disabled.svg";
import TiktokDisabled from "/images/platforms/tiktok_disabled.svg";

export type PlatformIconType = {
  [key: string]: {
    default: string;
    selected: string;
    disabled: string;
    hover: string;
  };
};

export const platformIconData: PlatformIconType = {
  instagram: {
    default: Instagram,
    selected: InstagramSelected,
    disabled: InstagramDisabled,
    hover: InstagramHover,
  },
  facebook: {
    default: Facebook,
    selected: FacebookSelected,
    disabled: FacebookDisabled,
    hover: FacebookHover,
  },
  pinterest: {
    default: Pinterest,
    selected: PinterestSelected,
    disabled: PinterestDisabled,
    hover: PinterestHover,
  },
  youtube: {
    default: Youtube,
    selected: YoutubeSelected,
    disabled: YoutubeDisabled,
    hover: YoutubeHover,
  },
  tiktok: {
    default: Tiktok,
    selected: TiktokSelected,
    disabled: TiktokDisabled,
    hover: TiktokHover,
  },
};
